document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.secondary-media-video-container').forEach(container => {
    const card = container.closest('.card-wrapper') || container.closest('.card');
    const video = container.querySelector('video');
    const poster = container.querySelector('.secondary-video-poster');
    if (!card || !video) return;
    card.addEventListener('mouseenter', () => {
      if (video.readyState === 0) video.load();
      video.play().then(() => {
        video.classList.add('is-playing');
        if(poster) poster.style.opacity = '0';
      }).catch(e => console.log('Wait for load', e));
    });
    card.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
      video.classList.remove('is-playing');
      if(poster) poster.style.opacity = '1';
    });
  });
});